import React, { useEffect, useState } from 'react'
import classes from './WarehouseDetail.module.scss';
import Button from 'shared/components/form-input/button/Button';
import { Close } from '@mui/icons-material';
import IconEdit from 'assets/icon/IconEdit';
import { useDispatch } from 'react-redux';
import EventRegister, { EVENT_SHOW_POPUP, EVENT_SHOW_UPDATE_WAREHOUSE_POPUP } from 'utils/EventRegister';
import useTrans from 'hooks/use-trans';
import { actionsHolonInstance } from 'redux/holon-instance/action';
import Constants from 'utils/Constants';
import IconChecked from 'assets/icon/IconChecked';
import IconCheck from 'assets/icon/IconCheck';
import moment from 'moment';
import WrapContentBody from '../custom-body/WrapContentBody';
import actionWareHouse from 'redux/warehouse/action';
import useRouter from 'hooks/use-router';
import Box from '../../box/Box';
import BoxHeader from '../../box/BoxHeader';
import BoxTitle from '../../box/BoxTitle';
import BoxBody from '../../box/BoxBody';
import BoxRow from '../../box/BoxRow';
import BoxLabel from '../../box/BoxLabel';
import BoxContent from '../../box/BoxContent';
import BoxContentPopup from '../custom-body/BoxContentPopup';
import CommonValueAttributes from 'shared/components/form-input/common-value-attributes/CommonValueAttributes';

function WarehouseDetailPopup(props) {
    const { payload, showVisible } = props;
    const { t } = useTrans();
    const dispatch = useDispatch();
    const [dataHolonInstanceDetail, setHolonInstanceDetail] = useState([]);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const router = useRouter();
    const handleEdit = () => {
        EventRegister.emit(EVENT_SHOW_POPUP, {
            open: true,
            type: EVENT_SHOW_UPDATE_WAREHOUSE_POPUP,
            payload: {
                showHeader: false,
                customStyle: {
                    padding: 0,
                    borderTop: 0
                },
                title: t("warehouse.update_warehouse"),
                holonTemplateDetail: payload?.holonTemplateDetail,
                warehouse: payload?.warehouse,
            }
        })
    }

    useEffect(() => {
        if (payload?.holonTemplateDetail?.attributes?.length > 0 && payload?.warehouse.id) {
            setHolonInstanceDetail(payload?.holonTemplateDetail?.attributes?.map(x => {
                let indexDetail = payload?.warehouse.attributes?.findIndex(attribute => attribute.name == x?.key);
                return {
                    ...x,
                    [x?.key]: payload?.warehouse.attributes[indexDetail]?.value,
                    value: payload?.warehouse.attributes[indexDetail]?.value,
                    name: payload?.warehouse.attributes[indexDetail]?.name,
                }
            }))
        }
    }, [payload?.holonTemplateDetail, payload?.warehouse])

    const handleClose = () => {
        showVisible()
    }

    const handleDelete = () => {
        setLoadingDelete(true);
        dispatch({
            type: actionWareHouse.DELETE_WAREHOUSE,
            payload: payload?.warehouse?.id,
            callback: {
                success: () => {
                    dispatch({
                        type: actionWareHouse.GET_WAREHOUSE_LIST,
                        payload: {
                            ...router.getAll()
                        }
                    })
                    handleClose();
                    setLoadingDelete(false);
                },
                failed: () => {
                    setLoadingDelete(false);
                }
            }
        })
    }

    const onClose = () => {
        dispatch({
            type: actionsHolonInstance.GET_HOLON_INSTANCE_DETAIL_SUCCESS,
            payload: {}
        })
    }

    return (
        <BoxContentPopup>
            <WrapContentBody
                title={payload?.title}
                actionSectionTop={<Button onClick={handleEdit} color='gray' startIcon={<IconEdit color="currentColor" />} />}
                actionSectionBottom={<Button loading={loadingDelete} onClick={handleDelete} title={t("Holon_Template.delete")} />}
            >
                <div className={classes['Wrap-Content']}>
                    <div className={classes['FormHas']}>
                        <Box>
                            <BoxHeader>
                                <BoxTitle>{t("warehouse.basic_information")}</BoxTitle>
                            </BoxHeader>
                            <BoxBody>
                                {
                                    dataHolonInstanceDetail?.map((x, key) => {
                                        return <BoxRow key={key}>
                                            <BoxLabel minWidth={140}>
                                                {x?.label}
                                            </BoxLabel>
                                            <BoxContent>
                                                <CommonValueAttributes x={x} />
                                            </BoxContent>
                                        </BoxRow>
                                    })
                                }
                            </BoxBody>
                        </Box>
                    </div>
                </div>
            </WrapContentBody>
        </BoxContentPopup>
    )
}

export default WarehouseDetailPopup